/**
 * RVRN Product — Specifications & Fitment JS
 *
 * Idempotent observer pattern. No-op when no .rvrn-psf on page.
 * Wires keyboard support and tracks accordion open/close analytics event.
 */
(function () {
  'use strict';

  const WRAPPER_SEL = '.rvrn-psf';

  function enhanceAccordion(root) {
    const details = root.querySelector('.rvrn-psf__details');
    if (!details) return;

    // Track expanded state for potential analytics
    details.addEventListener('toggle', function () {
      if (details.open) {
        root.setAttribute('data-expanded', 'true');
      } else {
        root.setAttribute('data-expanded', 'false');
      }
    });

    // Initialize
    root.setAttribute('data-expanded', details.open ? 'true' : 'false');
  }

  function initAll() {
    document.querySelectorAll(WRAPPER_SEL).forEach(enhanceAccordion);
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Idempotent: observe for dynamically injected sections
  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      var found = false;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        if (!added) continue;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType === 1) {
            if (node.matches && node.matches(WRAPPER_SEL)) {
              enhanceAccordion(node);
              found = true;
            } else if (node.querySelectorAll) {
              var nested = node.querySelectorAll(WRAPPER_SEL);
              if (nested.length) {
                nested.forEach(enhanceAccordion);
                found = true;
              }
            }
          }
        }
      }
      if (found && window.dispatchEvent) {
        window.dispatchEvent(new CustomEvent('rvrn:psf:updated'));
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  // Redispatch on Shopify editor section load
  document.addEventListener('shopify:section:load', function (e) {
    var container = document.getElementById('shopify-section-' + e.detail.sectionId);
    if (container) {
      var roots = container.querySelectorAll(WRAPPER_SEL);
      roots.forEach(enhanceAccordion);
    }
  });
})();
